<template>
    <common-content-spacer height="small" :isCenter="true">
        <checkbox-input
            class="create-company__map-switch"
            :label="$t('pages.company.create_company.package_step.monthly')"
            :secondLabel="$t('pages.company.create_company.package_step.yearly')"
            :value="isSubsciptionYearly"
            type="switch"
            labelPosition="left"
            @change="changeSubscription"
        ></checkbox-input>
        <div class="create-company__packages">
            <package-info
                v-for="packageOption in companyPackages.package_options"
                :key="packageOption.key"
                :class="getPackageClass(packageOption.class)"
                :packageOption="packageOption"
                :isSubsciptionYearly="isSubsciptionYearly"
                :regularYearly="regularYearly"
                :regularMonthly="regularMonthly"
                :subdomainYearly="subdomainYearly"
                :subdomainMonthly="subdomainMonthly"
                :currency="currency"
                @package-chosen="packageChosen"
            ></package-info>
        </div>
        <div>
            <common-icon class="create-company__icon" :name="'star'" size="small"></common-icon>
            {{ invoiceInfo }}
        </div>
    </common-content-spacer>
</template>

<script>
    import CheckboxInput from 'components/form-inputs/CheckboxInput.vue'
    import PackageInfo from 'components/page-elements/package/PackageInfo'
    import CompanyCreateEnum from 'enums/company_create.enum'
    import PackagePriceMixin from 'mixins/PackagePriceMixin'

    export default {
        mixins: [PackagePriceMixin],

        components: { CheckboxInput, PackageInfo },

        data() {
            return {
                isSubsciptionYearly: false,
                countryName: 'Serbia',
            }
        },

        computed: {
            companyPackages() {
                return CompanyCreateEnum[this.$i18n.locale]
            },
            invoiceInfo() {
                return this.$t('pages.company.create_company.invoice_info')
            },
        },

        methods: {
            changeSubscription() {
                this.isSubsciptionYearly = !this.isSubsciptionYearly
            },
            getPackageClass(packageClass) {
                return {
                    ['package-info']: true,
                    [`package-info__${packageClass}`]: true,
                }
            },

            packageChosen(chosenPackage) {
                this.emitEvent({
                    name: 'package-chosen',
                    payload: { chosenPackage: chosenPackage.toUpperCase(), isSubsciptionYearly: this.isSubsciptionYearly },
                })
            },
            changeCountry(country) {
                this.countryName = country
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .create-company {
        &__packages {
            display: flex;

            @include breakpoint(tablet-small) {
                display: block;
            }
        }

        &__icon {
            color: $color--accent-2;
            padding-bottom: 3px;
        }
    }
</style>
